define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilitySysStatusDomain = void 0;
    class FacilitySysStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FacilitySysStatusDomain.Active, value: "Active" },
                    { key: FacilitySysStatusDomain.Archived, value: "Archived" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FacilitySysStatusDomain.Active] = 0;
                this.KeyIndex[FacilitySysStatusDomain.Archived] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Active"] = 0;
                this.ValueIndex["Archived"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FacilitySysStatusDomain = FacilitySysStatusDomain;
    Object.defineProperty(FacilitySysStatusDomain, "Active", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FacilitySysStatusDomain, "Archived", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FacilitySysStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
